// extracted by mini-css-extract-plugin
module.exports = {"rulesGroupItem":"RulesGroupItem_rulesGroupItem__34fE_","imgContainer":"RulesGroupItem_imgContainer__2AyY4"};